import { Box, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TemaTarea = () => {
  
const { promptData, setPromptData} = useActividadesContext();
  const handleTema = (event) => {
    const tema = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        tema: tema 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'row',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
          Tema de la tarea *
        </Typography>
       
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.tema}
          placeholder="Escribe aquí el tema de la tarea. Ejemplo: comida saludable"
          onChange={handleTema}
          InputProps={{
            sx: {
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem', 
                color: '#336B87',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default TemaTarea;
